import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { TagTheme } from '../../tag/interfaces';

/**
 * @Unstable
 * Warning! This component is in active development and is not production ready.
 *
 * Documentation can be found in `storybook/stories/flights/flight-card.stories.mdx`
 */
@Component({
  selector: 'fcom-flight-card',
  templateUrl: './flight-card.component.html',
  styleUrls: ['./flight-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class FlightCardComponent {
  readonly TagTheme = TagTheme;
  /**
   * Flight type (Departure, Return).
   * This is optional information, that is being shown according to the context
   *
   * @example
   * Departure
   */
  type = input('');

  /**
   * Flight date (date, month, year).
   * This is optional information, that is being shown according to the context
   * (e.g. it is not being shown in the context of the flight search results within the booking flow).
   *
   * @example
   * 5 may 2020
   */
  date = input('');

  /**
   * Boolean indicating if the component is in teh greyed out state
   */
  disabled = input(false);

  /**
   * Boolean indicating if the component should have a divider before notifications/buttons
   */
  showDivider = input(false);

  /**
   * String for disrupted label
   */
  disruptedLabel = input('');

  fareDetail = input<string>();
}
